/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StoreProfileContact
 */
export interface StoreProfileContact {
    /**
     * 
     * @type {string}
     * @memberof StoreProfileContact
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreProfileContact
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreProfileContact
     */
    website?: string;
}

/**
 * Check if a given object implements the StoreProfileContact interface.
 */
export function instanceOfStoreProfileContact(value: object): value is StoreProfileContact {
    return true;
}

export function StoreProfileContactFromJSON(json: any): StoreProfileContact {
    return StoreProfileContactFromJSONTyped(json, false);
}

export function StoreProfileContactFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoreProfileContact {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] == null ? undefined : json['email'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'website': json['website'] == null ? undefined : json['website'],
    };
}

export function StoreProfileContactToJSON(json: any): StoreProfileContact {
    return StoreProfileContactToJSONTyped(json, false);
}

export function StoreProfileContactToJSONTyped(value?: StoreProfileContact | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'phoneNumber': value['phoneNumber'],
        'website': value['website'],
    };
}

